<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina"> ACEITE REPROCESO</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>                
            </v-card-text>
            <modal-ayuda></modal-ayuda>
         <!-- tabla despachos -->
            <v-card-text>
                <v-card class="mt-2">
                    <template>
                        <v-tabs
                            fixed-tabs
                            background-color="cyan darken-3"
                            dark
                            v-model="tab"
                        >
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                            <v-tab key="rep">
                                <v-card-title>
                                    Aceite Reproceso
                                </v-card-title>
                            </v-tab>
                        </v-tabs>
                    </template>

                    <v-tabs-items v-model="tab">
                        <v-tab-item  key="rep">
                            <v-row class="pa-2">
                                <v-col cols="3">
                                    <date-picker class="float-right" v-model="fecha" @change="cargarReprocesos" range-separator="|" range placeholder="Fecha Despachos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                                </v-col>
                                <v-col cols="6">
                                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                                </v-col>
                            </v-row>
                            <v-data-table 
                                :headers="cabeceras_ingresos"
                                :items="lista_ingresos"
                                :items-per-page="35"
                                item-class="filita"
                                class="elevation-2 mt-1"
                                dense
                            > 
                                <template v-slot:item.tk_origen="{ item }">
                                    <span>{{  estanque_origen(item) }}</span>
                                </template>  
                                <template v-slot:item.lote_aceite="{ item }">
                                    <span>{{  lote_origen(item) }}</span>
                                </template>  
                                <template v-slot:item.fecha="{ item }">
                                    <span>{{  moment(item.fecha).format('DD-MM-YYYY') }}</span>
                                </template>
                                <template v-slot:item.opciones="{ item }"> 
                                    <v-icon title="Detalle" color="blue" @click="showModalDetalle(item)" class="mx-2">edit</v-icon>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-card-text>
        </v-card>
        <modal-detalle
            :estanques="estanques"
            :lotes_externos="lotes_externos"
            @cargar_lotes="cargarLotes"
        ></modal-detalle>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import Data_Table from '@/components/shared/Data_Table.vue';
import ModalDetalle from '@/components/shared/Modal_Aceite_Reproceso_Detalle.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    data() {
        return {
            tab: null,
            fecha: new Date().toISOString().substr(0, 10),
            estanques: [],
            lotes_externos: [],
            lista_ingresos: [],
            cabeceras_ingresos:[
                { text: 'Fecha',        align: 'center',    sortable: true,     value: 'fecha',             class: 'cabecera',},
                { text: 'Origen',       align: 'center',    sortable: true,     value: 'bodega_origen',     class: 'cabecera',},
                { text: 'Estanque Origen',       align: 'center',    sortable: true,     value: 'tk_origen',     class: 'cabecera',},
                { text: 'Lote Aceite',       align: 'center',    sortable: true,     value: 'lote_aceite',     class: 'cabecera',},
                { text: 'Destino',      align: 'center',    sortable: true,     value: 'bodega_destino',    class: 'cabecera',},
                { text: 'Nro Embarque', align: 'center',    sortable: true,     value: 'nro_embarque',      class: 'cabecera',},
                { text: 'Guia',         align: 'center',    sortable: true,     value: 'guia',              class: 'cabecera',},
                { text: 'Cantidad Salida',     align: 'center',    sortable: true,     value: 'cantidad_salida',          class: 'cabecera',},
                { text: 'Cantidad Ingreso',     align: 'center',    sortable: true,     value: 'cantidad_ingreso',          class: 'cabecera',},
                { text: 'Opciones',     align: 'center',    sortable: true,     value: 'opciones',          class: 'cabecera',},
            ],
        }
    },
    mounted() {
        this.cargarEstanques();
        this.cargarLotes();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Ingreso de Aceite Reproceso`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra y se registran los movimientos de ingresos por reproceso`},
                {   tipo:`label`,   texto:`- En el recuadro de la izquierda, se filtran por fecha los movimientos de aceite despachados para reprocesarlos (en pantalla de Despacho de Aceite desde Bodegas Externas).`},
                {   tipo:`label`,   texto:`- En cada movimiento, al pulsar en el icono del lápiz, se abrirá un recuadro mostrando los detalles del ingreso de reproceso y la opción para modificarlos/crearlos. Adicionalmente, dentro del recuadro, se podrá crear un lote de aceite en caso de ser necesario.`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarReprocesos(){
            this.mostrarLoading({titulo: "Cargando reprocesos...", color: "green"});
            let fecha_ini = this.moment(this.fecha[0]).format('YYYY-MM-DD');
            let fecha_fin = this.moment(this.fecha[1]).format('YYYY-MM-DD');
            let data = {    "fecha_ini": fecha_ini,
                        "fecha_fin": fecha_fin  }
            let url = `${this.base_url}despacho_aceite/reprocesos`;
            await this.axios.post(url, data, this.headers).then(response => {
                this.lista_ingresos = response.data.data;
                this.ocultarLoading();
            }).catch(error => {
                console.error(error);
                this.errorMessage(error);
            });
        },
        async cargarEstanques() {
            const url = `${this.base_url}estanques_externos`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                console.log({estanques: res.data.data});
                this.estanques = res.data.data;
            }).catch((error)=>{
                console.error('error',error);
                this.errorMessage(error, "Error al cargar estanques externos ");
            });
        },
        async cargarLotes() {
            this.cargando = true;
            const url = `${this.base_url}lotes_externos`;
            await this.axios.get(url, this.headers).then((response)=>{
                console.log({lotes: response.data.data});
                this.lotes_externos = response.data.data;
            }).catch((error)=>{
                console.error('error',error);
            });
            this.cargando = false;
        },
        showModalDetalle(item) {
            this.$emit("abrir_modal_detalle", item);
        },
        estanque_origen(item) {
            return this.estanques.find(tk => tk.id === item.tk_origen).nombre;
        },
        lote_origen(item) {
            return this.lotes_externos.find(lote => lote.id === item.lote_aceite).nombre_lote;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'roles']),
    },
    components: {
        'data-table': Data_Table,
        DatePicker,
        ConfirmDialogue,
        'modal-detalle': ModalDetalle,
        'modal-ayuda': ModalAyudas,
    }
}
</script>
<style scoped>
    .mx-datepicker{ width: 100% !important;}
</style>